<template>
	<div class="tab-content" v-show="isActive">
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			required: true,
		},
		selected: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			isActive: false,
		};
	},

	mounted() {
		this.isActive = this.selected;
	},
};
</script>

<style lang="stylus" scoped></style>
